// Was das Argus-Modul zum Baum beiträgt (lib/shell/tree.svelte.ts hängt es
// ein): die Stände unter „Bilder prüfen" und die Zahlen rechts an den
// Seiten. Seiten und Register selbst kommen aus routen.ts.

import type { BaumKnoten } from "../../lib/shell/baum-knoten.svelte";
import { offenText, sammelnZustand } from "./argus";
import { getArgus } from "./argus.svelte";

/** Dinge unter ihrer Seite (wie DINGE in tree.svelte.ts). */
// Tim 29.10.2026: „Lass mal nur eine Karte machen“ -- die Proben wählt die
// Seite selbst (Dropdown „Probe“), im Baum steht nur „Bilder prüfen“.
export const ARGUS_DINGE: Record<string, () => BaumKnoten[]> = {};

/** Text rechts an einer Seite des Moduls („212 offen", „3"). */
export const ARGUS_ZAHLEN: Record<string, () => string> = {
  "/argus/sammeln": () => {
    const sa = getArgus()?.sammeln;
    if (sa?.status?.aktiv) return sammelnZustand(sa.status).text;
    if (sa?.status?.phase === "fehler") return "Fehler";
    return sa?.werte && !sa.werte.an ? "aus" : sa ? sa.um : "";
  },
  "/argus/pruefen": () => offenText(getArgus()?.gesamt.offen ?? 0),
  "/argus/modelle": () => {
    const n = getArgus()?.modelle.length ?? 0;
    return n ? String(n) : "";
  },
  "/argus/modelle/hailo": () => {
    const n = getArgus()?.modelle.filter((m) => m.hef).length ?? 0;
    return n ? String(n) : "";
  },
};
